
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { State, Toggle } from 'react-powerplug'
import FormFieldTextArea from './form-field-text-area'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formfieldtextarea"
    }}>{`FormFieldTextArea`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "text-area"
    }}>{`Text area`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For multiple lines of text.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={1} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldTextArea\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldTextArea
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldTextArea {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldTextArea" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={2} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldTextArea\n      {...state}\n      error=\"Notice\"\n      labelText=\"Label\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldTextArea
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldTextArea {...state} error="Notice" labelText="Label" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldTextArea" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={3} __code={'<FormFieldTextArea labelText=\"Label\" id=\"123\" value=\"Text value\" disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldTextArea
    }} mdxType="Playground">
  <FormFieldTextArea labelText="Label" id="123" value="Text value" disabled mdxType="FormFieldTextArea" />
    </Playground>
    <p><strong parentName="p">{`Placeholder`}</strong></p>
    <Playground __position={4} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldTextArea\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldTextArea
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldTextArea {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} placeholder="Text placeholder" mdxType="FormFieldTextArea" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "text-area-optional"
    }}>{`Text area (optional)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For multiple lines of text.`}</p>
    <Playground __position={6} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldTextArea\n      {...state}\n      labelText=\"Label\"\n      labelTag=\"Tag\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldTextArea
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldTextArea {...state} labelText="Label" labelTag="Tag" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldTextArea" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "text-area-helper"
    }}>{`Text area (helper)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For multiple lines of text.`}</p>
    <Playground __position={8} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldTextArea\n      {...state}\n      helperText=\"Helper text\"\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldTextArea
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldTextArea {...state} helperText="Helper text" labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldTextArea" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormFieldTextArea} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;